module.exports = __webpack_public_path__ + "img/herb-basil-350x184.fae02a8c.jpg";